var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldUserRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91 21.5c0 .28.22.5.5.5h17.18c.28 0 .5-.22.5-.5 0-4.14-4.08-7.5-9.09-7.5s-9.09 3.36-9.09 7.5z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 4.388c-.19-.32-.44-.64-.71-.92a4.96 4.96 0 0 0-3.27-1.45c-1.36-.09-2.75.41-3.8 1.45A4.96 4.96 0 0 0 7 7.078c.01 1.25.51 2.5 1.46 3.46.66.66 1.47 1.1 2.34 1.3.47.12.97.18 1.47.14 1.19-.05 2.35-.52 3.26-1.44a4.984 4.984 0 0 0 1.32-4.74c-.12-.49-.32-.97-.6-1.41zm-3.57 4.61-.69-.69-.66.66c-.36.36-.96.36-1.32 0a.933.933 0 0 1-.01-1.32l.66-.66-.64-.62a.966.966 0 0 1 0-1.34c.37-.36.96-.36 1.34 0l.62.64.67-.67c.36-.36.95-.36 1.32 0 .36.36.36.96 0 1.32l-.66.66.69.7c.36.36.36.96 0 1.32-.36.36-.96.36-1.32 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldUserRemove);
export default __webpack_public_path__ + "static/media/vuesax-bold-user-remove.e730cb3a732a6a1a4713611c52b98060.svg";
export { ForwardRef as ReactComponent };